import { type CalmingTechnique } from '@/services/content'
import styles from './SOSTechniqueCard.module.css'

interface Props {
  technique: CalmingTechnique
  currentIndex: number
  total: number
  onNext: () => void
  onPrev: () => void
  onTryBreathing: () => void
}

export default function SOSTechniqueCard({
  technique,
  currentIndex,
  total,
  onNext,
  onPrev,
  onTryBreathing,
}: Props) {
  return (
    <div className={styles.card}>
      <div className={styles.counter}>
        {currentIndex + 1} of {total}
      </div>

      <h2 className={styles.title}>{technique.title}</h2>
      <p className={styles.description}>{technique.description}</p>

      <div className={styles.steps}>
        {technique.steps.map((step, i) => (
          <div key={i} className={styles.step}>
            <span className={styles.stepNumber}>{i + 1}</span>
            <span className={styles.stepText}>{step}</span>
          </div>
        ))}
      </div>

      <div className={styles.meta}>
        <span className={styles.duration}>{technique.duration}s</span>
        <span className={styles.type}>{technique.type}</span>
      </div>

      <div className={styles.actions}>
        <div className={styles.navButtons}>
          <button
            className={styles.navButton}
            onClick={onPrev}
            disabled={currentIndex === 0}
          >
            Previous
          </button>
          <button
            className={styles.navButton}
            onClick={onNext}
            disabled={currentIndex === total - 1}
          >
            Next
          </button>
        </div>
        <button className={styles.breatheButton} onClick={onTryBreathing}>
          Try Breathing Exercise
        </button>
      </div>
    </div>
  )
}
